import {Component} from '@angular/core';
import {Notification} from "../../_types/notification";
import {NavigationEnd, Router} from "@angular/router";
import {NotificationService} from "../../_services/notification.service";
import {ContentService} from "../../_services/content.service";
import {LocalStorageService} from "../../_services/local-storage.service";
import {combineLatest, debounceTime, filter, Observable, switchMap, take} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {Community} from "../../_types/communities";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-notifications-list',
    templateUrl: './notifications-list.component.html',
    styleUrl: './notifications-list.component.scss'
})
export class NotificationsListComponent {
    notifications: Notification[] = [];

    constructor(
        private readonly router: Router,
        private readonly notificationService: NotificationService,
        private readonly contentService: ContentService,
        private readonly localStorageService: LocalStorageService,
        public dialog: MatDialog,
        private readonly matDialog: MatDialogRef<NotificationsListComponent>,
    ) {
        this.notificationService.getNotifications().subscribe(r => {
            this.notifications = r;
        })
        const community$: Observable<Community | null> = this.contentService.getCurrentDashboardCommunity();
        const router$: Observable<NavigationEnd> = this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        combineLatest([community$, router$])
            .pipe(
                debounceTime(200),
                switchMap((): Observable<Notification[]> => this.notificationService.getNotifications()),
                takeUntilDestroyed()
            )
            .subscribe(res => {
                this.notifications = res;
            });
    }

    get selectedCommunity(): Community | null {
        return this.localStorageService.getItem<Community | null>('lastSelectedCommunity', null);
    }

    markNotificationAsRead(notification: Notification): void {
        this.notificationService.markNotificationAsRead(notification.id).pipe(take(1))
            .subscribe((): void => {
                notification.is_read = true;
            });
    }

    trackByNotificationId(index: number, notification: any): number {
        return notification.id;
    }

    notificationRedirect(notification: Notification): void {
        this.notificationService.notificationRedirect(notification)
    }

}
